import Cookies from 'js-cookie';
import { create } from 'zustand';

export default create((set) => {
    const token = Cookies.get('token');
    return {
        authToken: token != 'null' ? token : null,
        userProfile: null,
        setAuthToken: (authToken) =>
            set(() => {
                if (authToken != null)
                    Cookies.set('token', authToken, { expires: 7, path: '/' });
                return { authToken };
            }),
        setUserProfile: (profile) => set(() => ({ userProfile: profile })),
        logout: () =>
            set(() => {
                let count = 0;
                while (Cookies.get('token') && count++ < 3)
                    Cookies.remove('token');
                return { authToken: null, userProfile: null };
            }),
    };
});
